import React from 'react';
import Bootstrap from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import AdelaideRivieraHotelStay from '../../pactum-server/stubs/stayContentFactory';
import ParkRegisNorthQuayOffering from '../../pactum-server/stubs/offeringFactory';

const StaySummary: React.FC = () => {
  const args = {
    product: ParkRegisNorthQuayOffering({}),
    stay: AdelaideRivieraHotelStay({}),
    onAction: (data) => alert(JSON.stringify(data)),
    fullWidth: true,
  };

  return (
    <Bootstrap>
      <MicroComponent micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'StaysSummary' }} {...args} />
    </Bootstrap>
  );
};

export default StaySummary;
